import { createReturnBackup } from "../../../../../api/backup/backup";

export const CreateReturnOrderBackup = async (backup) => {
  try {
    const response = await createReturnBackup(backup);
    return response.data;
  } catch (error) {
    return error.response?.data;
  }
};
